import React from 'react';
import { useLocation, Routes, Route, Navigate } from 'react-router-dom';
import LabsAppBar, { ActionButton, TabItem } from '../../components/LabsAppBar';
import SchemaEditPage from './SchemaEditPage';
import SchemaListPage from './SchemaListPage';
import IntegrationsTab from './settings/IntegrationsTab';
import { SchemaType } from '../../types/schema';
import ClustersTab from './settings/ClustersTab';
import ConsentSettingsTab from './settings/ConsentSettingsTab';
import UserManagementTab from './settings/UserManagementTab';

const SettingsPage: React.FC = () => {
  const location = useLocation();

  const tabs: TabItem[] = [
    { label: 'Integrations', path: '/labs/settings/integrations' },
    // { label: 'Clusters', path: '/labs/settings/clusters' },
    // { label: 'Consent Settings', path: '/labs/settings/consent-settings' },
    // { label: 'User Management', path: '/labs/settings/user-management' },
  ];

  let breadcrumbs = [];
  let actions: ActionButton[] = [];
  let pageTitle = 'Settings';
  let pageIcon: string | undefined = 'Settings';

  const activeTab = tabs.find(tab => location.pathname.startsWith(tab.path));
  if (activeTab) {
    breadcrumbs = [{ name: pageTitle, iconName: pageIcon }]
  } else {
    breadcrumbs = [{ name: pageTitle, iconName: pageIcon }];
  }

  return (
    <div className="flex flex-col h-full">
      <LabsAppBar
        breadcrumbs={breadcrumbs}
        actions={actions}
        tabs={tabs}
      />
      <div className="flex-1 overflow-y-auto p-4 sm:p-6 lg:p-8 min-w-[800px]">
        <div className="flex flex-col gap-10 max-w-9xl mx-auto">
          <Routes>
            <Route path="customer-schemas" element={<SchemaListPage schemaType={SchemaType.CustomerSchema} />} />
            <Route path="vendor-schemas" element={<SchemaListPage schemaType={SchemaType.VendorSchema} />} />
            <Route path="pipeline-schemas" element={<SchemaListPage schemaType={SchemaType.PipelineSchema} />} />
            <Route path="integrations" element={<IntegrationsTab />} />
            <Route path="clusters" element={<ClustersTab />} />
            <Route path="consent-settings" element={<ConsentSettingsTab />} />
            <Route path="user-management" element={<UserManagementTab />} />
            <Route path="schema-edit/:schemaName" element={<SchemaEditPage />} />
            <Route path="*" element={<Navigate to="/labs/settings/customer-schemas" replace />} />
          </Routes>
        </div>
      </div>
    </div>
  );
};

export default SettingsPage;
